import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { handleUnauthorized } from "../../utils/apiHelper";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DangerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";
import Multiselect from "multiselect-react-dropdown";

const SendNotificationNew = () => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [userType, setUserType] = useState("");
  const [selectType, setSelectType] = useState("all");
  const [selectUsers, setSelectUsers] = useState([]);
  const [users, setUsersData] = useState([]);
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
   const [isVisible, setisVisible] = useState("0");
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
  const authToken = localStorage.getItem("authToken");
  const fetchUserData = async (type = userType) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/admin/userlistnotification`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }
      const data = await response.json();
      if (selectType === "all") {
        const allUserIds = (data.users || []).map(user => user._id);
        setSelectUsers(allUserIds); // Save the IDs
      }
      const cleanedUsers = (data.users || []);
      setUsersData(cleanedUsers);

    } catch (error) {
      clearMessage();
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserData();
  }, [id, navigate, authToken, isEditMode]);
  const clearMessage = () => {
    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 3000);
  };
  const validateInputs = () => {
    const newErrors = {};
    if (!title) {
      newErrors.title = "Title is required";
    } else {
      if (!/[A-Za-z]/.test(title)) {
        newErrors.title = "Title must include at least one letter";
      }
      if (title.length < 3) {
        newErrors.title = "Title must be at least 3 characters long";
      }
    }
    if (selectType === "SelectedUser" && selectUsers.length === 0) {
      newErrors.selectUsers = "Please select at least one user";
    }
    if (!description) {
      newErrors.description = "Description is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateInputs()) return;
    let userId;
    if(selectType !== 'all')
    {
       userId = selectUsers.map(user => user.id);
    }
    else
    {
      userId = selectUsers;
    }
    setLoading(true);
    try {
      const method = isEditMode ? "PUT" : "POST";
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/sendNotificationAdmin`;

      const response = await fetch(API_ENDPOINT, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          title: title.trim(),
          notificationType:"admin_message",
          userIds: userId,
          message:description,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        setSuccessMessage("Notification sent successfully!");
        clearMessage();
        setTimeout(() => navigate("/notification"), 3000);
      } else {
        setErrorMessage(data.message || "Something went wrong");
        clearMessage();
      }
    } catch (error) {
      setErrorMessage(error?.message || "Something went wrong");
      clearMessage();
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header"></div>
          <div className="card-body">
            {successMessage && <SuccessAlert message={successMessage} />}
            {errorMessage && <DangerAlert message={errorMessage} />}

            <form className="row gy-3" onSubmit={handleSubmit} noValidate>
              <div className="col-md-12">
                <label className="form-label">
                  Title <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.title ? "is-invalid" : ""}`}
                  value={title}
                  placeholder="Enter Title"
                  onChange={(e) => {
                    setTitle(e.target.value.trimStart());
                    setErrors((prev) => ({ ...prev, title: "" }));
                  }}
                />
                {errors.title && <p className="text-danger mt-1">{errors.title}</p>}
              </div>



              <div className="col-md-12 type">
                <label className="form-label">
                  Select Type <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-control ${errors.selectType ? "is-invalid" : ""}`}
                  value={selectType}
                  onChange={(e) => {
                    if(e.target.value != 'all')
                    {
                      setSelectUsers([]);
                    }
                    setSelectType(e.target.value);
                    setErrors((prev) => ({ ...prev, selectType: "" }));
                  }}
                >
                  <option value="all">All</option>
                  <option value="SelectedUser">Selected User</option>
                </select>
                {errors.selectType && <p className="text-danger mt-1">{errors.selectType}</p>}
              </div>

              {selectType === "SelectedUser" && (
                <div className="col-md-12">
                  <label className="form-label">
                    Select Users <span className="text-danger">*</span>
                  </label>
                  <Multiselect
                 options={users.map((u) => ({
                  name: `${u.fullName}`,
                  id: u._id
                }))}
                    selectedValues={selectUsers}
                    onSelect={setSelectUsers}
                    onRemove={setSelectUsers}
                    displayValue="name"

                    placeholder={selectUsers.length === 0 ? "Select user types" : ""}
                    style={{
                      chips: { background: "#0d6efd", fontSize: "13px" },
                      searchBox: {
                        border: "1px solid #ced4da",
                        borderRadius: "0.375rem",
                        padding: "8px",
                      },
                      optionContainer: {
                        border: "1px solid #ced4da",
                      },
                      option: {
                        color: "#000",
                        backgroundColor: "#fff",
                      },
                    }}
                    className={`${errors.selectUsers ? "is-invalid" : ""}`}
                  />
                  {errors.selectUsers && <p className="text-danger mt-1">{errors.selectUsers}</p>}
                </div>
              )}

              <div className="col-md-12">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="5"
                  value={description}
                   placeholder="Enter Description"
                  onChange={(e) => {
                    setDescription(e.target.value.trimStart());
                    setErrors((prev) => ({ ...prev, description: "" }));
                  }}
                />
                {errors.description && <p className="text-danger mt-1">{errors.description}</p>}
              </div>

              <div className="col-12">
                <button className="btn btn-primary mt-3 float-end" type="submit">
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendNotificationNew;
